import { useEffect, useState } from "react";
import Icon from "../Icon";
import Caption from "./Caption";
import DownloadElements from "./ManualDownloadElements";

const Image = ({ selectedChart, mode, publicationType }) => {

    const [img, setImg] = useState(selectedChart.image);

    useEffect(() => {
        if (mode === "dark" && selectedChart.imagedark) {
            setImg(selectedChart.imagedark);
        }
        else { setImg(selectedChart.image); }
    }, [selectedChart, mode])

    return (<>
        {selectedChart.title && <h3 className='highcharts-title' dangerouslySetInnerHTML={{ __html: selectedChart.title }}></h3>}
        <DownloadElements chart={selectedChart} PType={publicationType} mode={mode} />
        {selectedChart.subtitle && <h6 className='highcharts-subtitle' dangerouslySetInnerHTML={{ __html: selectedChart.subtitle }}></h6>}
        {img.endsWith(".svg") && <embed className="img image" src={`${window.PUBLICATION_DATA_URL}images/${img}`} />}
        {!img.endsWith(".svg") &&
            <div className="image-container">
                {selectedChart.zoom && <a href={`${window.PUBLICATION_DATA_URL}images/${img}`} target="blank"
                >
                    <img className="img image" src={`${window.PUBLICATION_DATA_URL}images/${img}`}  alt={selectedChart.title} />
                    <button
                        className={`button`}>
                        <Icon className="white" icon="zoom-in" />
                    </button>
                </a>
                }
                {!selectedChart.zoom && <img className="img image" src={`${window.PUBLICATION_DATA_URL}images/${img}`} alt={selectedChart.title}/>}
            </div>}
        {selectedChart.caption && <Caption content={selectedChart.caption} />}
    </>)
}

export default Image;
